import { HardHat } from "lucide-react";
import React from "react";

/** Logos two-tone des sous-onglets Commercial › Configuration — couleurs figées, viewBox 40×40. */
const base = (size, style) => ({ width: size, height: size, flexShrink: 0, display: "inline-block", ...style });

export function EcheanciersIcon({ size = 26, style, ...rest }) {
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} aria-hidden="true" data-testid="cfg-icon-echeanciers" {...rest}>
      <rect x="6" y="9" width="28" height="25" rx="4" fill="#AFA9EC" />
      <rect x="6" y="9" width="28" height="7" rx="4" fill="#7F77DD" />
      <rect x="11" y="6" width="3" height="6" rx="1.5" fill="#7F77DD" />
      <rect x="26" y="6" width="3" height="6" rx="1.5" fill="#7F77DD" />
      <circle cx="26" cy="26" r="6" fill="#7F77DD" />
      <path d="M26 22.5v7M23.5 24h3.5a1.5 1.5 0 0 1 0 3h-2a1.5 1.5 0 0 0 0 3h3.5" fill="none" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function TypologiesIcon({ size = 26, style, ...rest }) {
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} aria-hidden="true" data-testid="cfg-icon-typologies" {...rest}>
      <path d="M20 5L34 12L20 19L6 12Z" fill="#9FE1CB" />
      <path d="M6 20L20 27L34 20" fill="none" stroke="#2A9A7A" strokeWidth="3" strokeLinejoin="round" />
      <path d="M6 27L20 34L34 27" fill="none" stroke="#1D9E75" strokeWidth="3" strokeLinejoin="round" />
    </svg>
  );
}

export function VerrouillageIcon({ size = 26, style, ...rest }) {
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} aria-hidden="true" data-testid="cfg-icon-verrouillage" {...rest}>
      <rect x="9" y="18" width="22" height="16" rx="3" fill="#FAC775" />
      <path d="M14 18v-4a6 6 0 0 1 12 0v4" fill="none" stroke="#E0822E" strokeWidth="3" strokeLinecap="round" />
      <circle cx="20" cy="25" r="2.4" fill="#C77F12" />
      <rect x="18.8" y="26.5" width="2.4" height="4.5" rx="1.2" fill="#C77F12" />
    </svg>
  );
}

export function ListesIcon({ size = 26, style, ...rest }) {
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} aria-hidden="true" data-testid="cfg-icon-listes" {...rest}>
      <rect x="6" y="8" width="28" height="24" rx="3" fill="#AFA9EC" />
      <path d="M11 15.5 L13.5 18 L18 13.5" fill="none" stroke="#7F77DD" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 25.5 L13.5 28 L18 23.5" fill="none" stroke="#7F77DD" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="21" y="15" width="9" height="2.4" rx="1.2" fill="#7F77DD" /><rect x="21" y="25" width="9" height="2.4" rx="1.2" fill="#7F77DD" />
    </svg>
  );
}

export function EmailsIcon({ size = 26, style, ...rest }) {
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} aria-hidden="true" data-testid="cfg-icon-emails" {...rest}>
      <rect x="5" y="9" width="30" height="22" rx="3" fill="#AFA9EC" />
      <path d="M7 12 L20 22 L33 12" fill="none" stroke="#7F77DD" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ChampsIcon({ size = 26, style, ...rest }) {
  return (
    <svg viewBox="0 0 40 40" style={base(size, style)} aria-hidden="true" data-testid="cfg-icon-champs" {...rest}>
      <rect x="6" y="8" width="28" height="7" rx="2.5" fill="#1f5c4a" /><circle cx="29" cy="11.5" r="2.4" fill="#35C88F" />
      <rect x="6" y="17" width="28" height="7" rx="2.5" fill="#1f5c4a" /><circle cx="11" cy="20.5" r="2.4" fill="#8a8a8f" />
      <rect x="6" y="26" width="28" height="7" rx="2.5" fill="#1f5c4a" /><circle cx="29" cy="29.5" r="2.4" fill="#35C88F" />
    </svg>
  );
}

/** Étapes des travaux — Lucide HardHat (#E0A42E), sans fond coloré. */
export function EtapesIcon({ size = 26, style, ...rest }) {
  return <HardHat size={size} style={{ color: "#E0A42E", ...style }} strokeWidth={1.8} {...rest} />;
}

export const CRM_CONFIG_ICONS = { echeanciers: EcheanciersIcon, etapes: EtapesIcon, typologies: TypologiesIcon, verrouillage: VerrouillageIcon, listes: ListesIcon, emails: EmailsIcon, champs: ChampsIcon };
